import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=ccbda838&scoped=true&"
import script from "./task.js?vue&type=script&lang=js&"
export * from "./task.js?vue&type=script&lang=js&"
import style0 from "./Task.vue?vue&type=style&index=0&id=ccbda838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbda838",
  null
  
)

export default component.exports